import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { errorSwal } from '../../../helper/swalHelpers';
import { Button, Col, Container, Row } from 'react-bootstrap';

import ytIcon from '../../../img/footer/youtube.svg';
import liIcon from '../../../img/footer/linkedin.svg';
import fbIcon from '../../../img/footer/icono_fb.svg';
import crmLogo from '../../../img/footer/CRMLogo.svg';
import igIcon from '../../../img/footer/instagram.svg';
import clienteAxios from '../../../configAxios/configAxios';
import ubicacionIcon from '../../../img/footer/placeholder.svg';
import iconTelefono from '../../../img/footer/Icon_telefono.svg';
import logoMobile from '../../../img/footer/blanco_logo_hyundai.svg';
import './footer.css';
import Cookie from '../cookie/cookie';
import { agregarQuery } from '../../redux/actions/queryActions';
// import Cookies from 'js-cookie'

const Footer = ({ float, floatR }) => {
    // const hasCookiesData = Cookies.get('hcb-cookie');
    const [datos, setDatos] = useState([]);
    const [dataBtnIcon] = datos?.filter(element => element.Etiqueta === 'BTN_ICON');
    const [dataBtnPDF] = datos?.filter(element => element.Etiqueta === 'BTN_PDF');
    // console.log(hasCookiesData);

    useEffect(() => {
        const fetchDatosFooter = async () => {
            try {
                let response = await clienteAxios.get('Parametro/activo/FOOTER');
                if (response.status === 200) {
                    let data = response.data.data;
                    setDatos(data);
                    return;
                }
                errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");
            } catch (error) {
                errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");
            }
        }
        fetchDatosFooter();
    }, []);

    const dispatch = useDispatch();
    const history = useHistory();

    const queryState = useSelector((state) => state.query.search);
    const query = window.location.search.substring(1)

    useEffect(() => {
        if (!queryState && query) {
            dispatch(agregarQuery(query))
        }
        if (queryState) {
            history.replace({ search: queryState })
        }
    }, [])


    return (
        <footer>
            <Container fluid className="footer-hyundai d-none d-md-block" id="footer-hyundai">
                <Cookie />
                <Row >
                    <Col md={5} lg={5} className="mt-4 my-auto ">
                        {datos && datos.length > 0 &&
                            datos.map(dato =>
                                dato.Etiqueta === "LOGO" &&
                                <img key={dato.idParametro} src={dato.Valor} className=" w-75 h-75 ml-lg-5" alt={dato.Descripcion} />
                            )
                        }
                    </Col>
                    <Col md={5} lg={4} className="mt-4">
                        <Row>
                            <Col>
                                <p className="title-footer-hyundai f-responsive-14">Contáctanos vía:</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="auto" className="mt-2 pr-0">
                                <img src={ubicacionIcon} alt="ubicacion-hyundai" />
                            </Col>
                            <Col xs="auto" className="pr-0">
                                {datos && datos.length > 0 &&
                                    datos.map((dato, i) => dato.Etiqueta === "DIRECCION" && <p key={i} className="text-footer-hyundai mb-1">{dato.Descripcion} <br /> {dato.Valor}</p>)
                                }
                            </Col>
                        </Row>

                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "TELEFONO" &&
                                <Row key={i}>
                                    <Col xs="auto" className="pr-0">
                                        <img src={iconTelefono} alt="telefono-hyundai" />
                                    </Col>
                                    <Col xs="auto">
                                        <a href={`tel:${dato.Valor}`} target="_blank" rel="noopener noreferrer"><p key={i} className="text-footer-hyundai">{dato.Valor}</p></a>
                                    </Col>
                                </Row>
                            )}
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "LINEA" &&
                                <Row key={i}>
                                    <Col xs="auto" className="pr-0">
                                        <img src={iconTelefono} alt="linea-hyundai" />
                                    </Col>
                                    <Col xs="auto">
                                        <a href={`tel:${dato.Valor}`} target="_blank" rel="noopener noreferrer"><p key={i} className="text-footer-hyundai">{dato.Valor}</p></a>
                                    </Col>
                                </Row>
                            )}
                    </Col>
                    <Col md={2} lg={3} className="mt-4 my-auto text-right">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "LOGO_INDUMOTORA" && <img key={dato.Etiqueta} src={dato.Valor} className="mr-5 w-75 h-75" alt="Indumotora-Hyundai" />)
                        }
                    </Col>
                </Row>
                <Row >
                    <Col md={5} lg={5} className="mt-2 align-self-end my-auto">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "DEALER" &&
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={dato.Etiqueta}>
                                    <Button variant="outline-light parrafo-hyundai ml-lg-5 px-xl-4 btn-square btn-acciones">
                                        <h5 className="parrafo-hyundai d-inline text-white mr-2">
                                            Ingresar a
                                        </h5>
                                        <img src={crmLogo} className="py-2 img-fluid" width="50px" alt="Dealer-Hyundai" />
                                    </Button>
                                </a>
                            )
                        }
                        {
                            dataBtnIcon &&
                            <a href={dataBtnPDF?.Valor} target="_blank" rel="noopener noreferrer" className="px-3">
                                <Button variant="outline-light parrafo-hyundai ml-lg-1 px-xl-4 btn-square btn-acciones">
                                    <h5 className="parrafo-hyundai d-inline text-white mr-2">
                                        {dataBtnIcon?.Descripcion}
                                    </h5>
                                    <img
                                        src={dataBtnIcon?.Valor}
                                        className="py-1 img-fluid"
                                        style={{ maxHeight: '32px' }}
                                        alt="Icono carroceros certificados"
                                    />
                                </Button>
                            </a>
                        }

                    </Col>
                    <Col md={7} lg={7} className="mt-2">
                        <Row>
                            <Col md="auto" lg="auto" xl="auto">
                                <p className="title-footer-hyundai mb-2 f-responsive-14">Nuestras redes:</p>
                                {datos && datos.length > 0 &&
                                    datos.map((dato, i) => dato.Etiqueta === "FACEBOOK" &&
                                        <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={dato.Etiqueta}>
                                            <Button variant="outline-light mr-2 btn-square btn-redes btn-acciones"><img src={fbIcon} className="icon-footer" alt="facebook-hyundai" /></Button>
                                        </a>
                                    )
                                }
                                {datos && datos.length > 0 &&
                                    datos.map((dato, i) => dato.Etiqueta === "INSTAGRAM" &&
                                        <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={dato.Etiqueta}>
                                            <Button variant="outline-light mr-2 btn-square btn-redes btn-acciones"><img src={igIcon} className="icon-footer" alt="instagram-hyundai" /></Button>
                                        </a>
                                    )
                                }
                                {datos && datos.length > 0 &&
                                    datos.map((dato, i) => dato.Etiqueta === "YOUTUBE" &&
                                        <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={dato.Etiqueta}>
                                            <Button variant="outline-light mr-2 btn-square btn-redes btn-acciones"><img src={ytIcon} className="icon-footer" alt="youtube-hyundai" /></Button>
                                        </a>
                                    )
                                }
                                {datos && datos.length > 0 &&
                                    datos.map((dato, i) => dato.Etiqueta === "LINKEDIN" &&
                                        <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={dato.Etiqueta}>
                                            <Button variant="outline-light btn-square btn-redes btn-acciones"><img src={liIcon} className="icon-footer" alt="linkedin-hyundai" /></Button>
                                        </a>
                                    )
                                }
                            </Col>
                            <Col md="auto" lg="auto" xl="auto">
                                <Link to="/nosotros">
                                    <p className="title-footer-hyundai mb-2 link-contacto f-responsive-14">Ir a nosotros</p>
                                </Link>
                            </Col>
                            {/* <Col md="auto" lg="auto" xl="auto" >
                                <Link to="/contactanos">
                                    <p className="ml-xl-4 title-footer-hyundai link-contacto f-responsive-14">Contáctanos</p>
                                </Link>
                            </Col> */}
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <hr style={{ background: "#FFF", opacity: 0.3 }} />
                    </Col>
                </Row>
                <Row className={`${float && "padding-footer"} ${floatR && "padding-footer-xl"} text-center justify-content-center`}>

                    <Col xs={12} md={3} className="">
                        <Link to="/terminos">
                            <p className="text-footer-hyundai">Términos y condiciones</p>
                        </Link>
                    </Col>
                    <Col xs={12} md={3} className="">
                        <Link to="/politicas">
                            <p className=" text-footer-hyundai">Políticas de Privacidad</p>
                        </Link>
                    </Col>
                    <Col xs={12} md={3} className="">
                        <Link to="/derechos-del-consumidor">
                            <p className="text-footer-hyundai">Derechos del consumidor</p>
                        </Link>
                    </Col>
                    {datos && datos.length > 0 &&
                        datos.map((dato, i) => dato.Etiqueta === "DENUNCIAS" &&
                            <Col xs={12} md={3} className="">
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <p className="text-footer-hyundai">{dato.Descripcion}</p>
                                </a>
                            </Col>
                        )
                    }
                </Row>
            </Container>
            <Container fluid className="footer-hyundai px-4 px-md-0 d-md-none ">
                <Cookie />
                <Row>
                    <Col className="mt-4 text-center">
                        <img src={logoMobile} className="ml-xl-4 img-fluid" alt="Hyundai Camiones y Buses" />
                        {/* {datos && datos.length > 0 &&
                            datos.map(dato => dato.Etiqueta === "LOGO" && <img key={dato.idParametro} src={dato.Valor} className="ml-xl-4 img-fluid" alt={dato.Descripcion} />)
                        } */}
                    </Col>
                    <Col className="mt-4 ml-3 text-center">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "LOGO_INDUMOTORA" && <img key={i} src={dato.Valor} className="img-fluid" alt="Indumotora-Hyundai" />)
                        }
                    </Col>
                </Row>
                <Row>
                    <Col className="p-0">
                        <hr className="my-3" style={{ background: "#FFF", opacity: 0.3 }} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p className="title-footer-hyundai mb-1">Contáctanos vía:</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs="auto pr-0">
                        <img src={ubicacionIcon} className="img-mobile-icon" alt="ubicacion-hyundai" />
                    </Col>
                    <Col className="px-2">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "DIRECCION" && <p key={i} className="text-footer-hyundai mb-1">{dato.Descripcion} <br /> {dato.Valor}</p>)
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs="auto" className="pr-0">
                        <img src={iconTelefono} alt="telefono-hyundai" className="img-mobile-icon" />
                    </Col>

                    <Col className="my-auto px-2">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "TELEFONO" && <a key={i} href={`tel:${dato.Valor}`} target="_blank" rel="noopener noreferrer"><p className="text-footer-hyundai mb-0">{dato.Valor}</p></a>)
                        }
                    </Col>
                </Row>

                {datos && datos.length > 0 &&
                    datos.map((dato, i) => dato.Etiqueta === "LINEA" &&
                        <Row key={i}>
                            <Col xs="auto" className="pr-0">
                                <img src={iconTelefono} alt="telefono-hyundai" className="img-mobile-icon" />
                            </Col>

                            <Col className="my-auto px-2">
                                <a href={`tel:${dato.Valor}`} target="_blank" rel="noopener noreferrer"><p key={i} className="text-footer-hyundai mb-0">{dato.Valor}</p></a>
                            </Col>
                        </Row>
                    )}
                <Row>
                    <Col className="mt-3" >
                        <p className="title-footer-hyundai mb-1">Nuestras Redes:</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs="auto">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "FACEBOOK" &&
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <Button variant="outline-light btn-square btn-redes btn-acciones btn-mobile-footer"><img src={fbIcon} className="icon-footer" alt="facebook-hyundai" /></Button>
                                </a>
                            )
                        }

                    </Col>
                    <Col xs="auto">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "INSTAGRAM" &&
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <Button variant="outline-light btn-square btn-redes btn-acciones btn-mobile-footer"><img src={igIcon} className="icon-footer" alt="instagram-hyundai" /></Button>
                                </a>
                            )
                        }

                    </Col>
                    <Col xs="auto">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "YOUTUBE" &&
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <Button variant="outline-light btn-square btn-redes btn-acciones btn-mobile-footer" >
                                        <img src={ytIcon} alt="youtube-hyundai" className="icon-footer" />
                                    </Button>
                                </a>
                            )
                        }
                    </Col>
                    <Col xs="auto">
                        {datos && datos.length > 0 &&
                            datos.map((dato, i) => dato.Etiqueta === "LINKEDIN" &&
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <Button variant="outline-light btn-square btn-redes btn-acciones btn-mobile-footer" >
                                        <img src={liIcon} alt="linkedin-hyundai" className="icon-footer" />
                                    </Button>
                                </a>
                            )
                        }
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-3">
                        <Link to="/nosotros">
                            <p className="title-footer-hyundai mb-1 link-contacto">Ir a nosotros</p>
                        </Link>
                    </Col>
                </Row>
                {/* <Row>
                    <Col className="mt-3">
                        <Link to="/contactanos">
                            <p className="title-footer-hyundai mb-1 link-contacto ">Contáctanos</p>
                        </Link>
                    </Col>
                </Row> */}
                <Row>
                    <Col className="p-0">
                        <hr style={{ background: "#FFF", opacity: 0.3 }} />
                    </Col>
                </Row>
                <Row>
                    {datos && datos.length > 0 &&
                        datos.map((dato, i) => dato.Etiqueta === "DEALER" &&
                            <Col xs={5} sm={4}>
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <Button variant="outline-light parrafo-hyundai btn-square btn-acciones font-btn">
                                        Ingresar a
                                        <img src={crmLogo} className="ml-1 img-fluid" alt="Dealer-hyundai" width="42px" />
                                    </Button>
                                </a>
                            </Col>
                        )
                    }
                    <Col xs={7} sm={8}>
                        {
                            dataBtnIcon &&
                            <a href={dataBtnPDF?.Valor} target="_blank" rel="noopener noreferrer">
                                <Button variant="outline-light parrafo-hyundai btn-square btn-acciones font-btn">
                                    {dataBtnIcon?.Descripcion}
                                    <img
                                        src={dataBtnIcon?.Valor}
                                        className="ml-2 img-fluid"
                                        alt="Dealer-hyundai"
                                        width="10px"
                                        height='10px'
                                    />
                                </Button>
                            </a>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col className="p-0">
                        <hr style={{ background: "#FFF", opacity: 0.3 }} />
                    </Col>
                </Row>
                <Row className={`${float ? "padding-footer" : ""} ${floatR ? "padding-footer-xl" : ""}`}>
                    <Col xs={12}>
                        <Link to="/terminos">
                            <p className="text-footer-hyundai mb-1">Términos y condiciones</p>
                        </Link>
                    </Col>
                    <Col xs={12}>
                        <Link to="/politicas">
                            <p className="text-footer-hyundai mb-1">Políticas de Privacidad</p>
                        </Link>
                    </Col>
                    <Col xs={12}>
                        <Link to="/derechos-del-consumidor">
                            <p className="text-footer-hyundai mb-1">Derechos del consumidor</p>
                        </Link>
                    </Col>
                    {datos && datos.length > 0 &&
                        datos.map((dato, i) => dato.Etiqueta === "DENUNCIAS" &&
                            <Col xs={12}>
                                <a href={dato.Valor} target="_blank" rel="noopener noreferrer" key={i}>
                                    <p className="text-footer-hyundai">{dato.Descripcion}</p>
                                </a>
                            </Col>
                        )
                    }
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
